import React from 'react';
import Container from '@material-ui/core/Container';
import {Card, CardContent, CardHeader, Typography} from '@material-ui/core';
import QuizTakeStartForm from './QuizTakeStartForm';


export default function QuizTakeStart(props) {
    return (
        <Container maxWidth="sm" className="start-quiz-container">
            <Card>
                <CardHeader
                    title={<Typography color="primary" className="authentication-title">Quiz - User
                        Details</Typography>}/>
                <CardContent>
                    <p>Please enter your user details before starting the quiz.</p>
                    <QuizTakeStartForm  {...{
                        onSubmit: props.onSubmit,
                        initialValues: props.initialValues
                    }} />
                </CardContent>
            </Card>
        </Container>
    );
}
